import { useRef } from 'react'
import styles from './MailmagazineLink.module.scss'
import Button from 'components/commons/Button/Button'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'

interface Props {
  white?: boolean
  noGsap?: boolean // もう使わないが、引数としては保持
}

const LinkItem = [
  {
    title: 'Contact',
    titleJa: 'お問い合わせ',
    description:
      'アプリやシステム開発、UX/UI改善など、お客さまのビジネスを成功に導いたサポート実績が多数ございます。お気軽にお問い合わせください。',
    button: 'お問い合わせ',
    red: true,
    src: '/images/icons/mailmagazine_contact.svg',
    href: '/contact/',
  },
  {
    title: 'Download',
    titleJa: '資料ダウンロード',
    description:
      '私たちのノウハウや業界別の事例など、提供するサービスについて詳細にまとめた資料になります。ぜひご一読ください。',
    button: '資料ダウンロード',
    red: false,
    src: '/images/icons/mailmagazine_download.svg',
    href: '/download/',
  },
  {
    title: 'Mail magazine',
    titleJa: 'メールマガジン',
    description:
      'UX/UIデザイン・システム内製化・DX推進についてのお役立ちメソッドや、限定イベントや最新事例などをお届けします。',
    button: 'メールマガジン',
    red: false,
    src: '/images/icons/mailmagazine_mailmagazine.svg',
    href: '/mailmagazine/',
  },
]

const MailmagazineLink: React.FC<Props> = ({ white }) => {
  const linksSection = useRef<HTMLDivElement>(null)
  const linkRefs = LinkItem.map(() => useRef<HTMLDivElement>(null))

  return (
    <article className={`${styles.main} ${white ? styles.white : ''}`}>
      <div className={styles.section} ref={linksSection}>
        <div className={styles.links}>
          {LinkItem.map((item, index) => {
            const isVisible = useElementVisible(linkRefs[index], 0.1)
            const fadeClass =
              index === 0 ? animationStyles.fadeOn : index === 1 ? animationStyles.fadeOn3 : animationStyles.fadeOn6

            return (
              <div
                key={index}
                className={`${styles.links_item} ${animationStyles.fade} ${isVisible ? fadeClass : ''}`}
                ref={linkRefs[index]}
              >
                <div className={styles.links_item_head}>
                  <div className={styles.links_item_head_title}>
                    <img src={item.src} alt={item.title} />
                    <div className={styles.links_item_head_title_text}>
                      <div className={styles.links_item_head_title_text_title}>{item.title}</div>
                      <p>{item.titleJa}</p>
                    </div>
                  </div>
                  <div className={styles.links_item_head_description}>
                    <p>{item.description}</p>
                  </div>
                </div>
                <div className={styles.links_item_button}>
                  {item.red ? (
                    <Button text={item.button} href={item.href} red="red" />
                  ) : (
                    <Button text={item.button} href={item.href} />
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </article>
  )
}

export default MailmagazineLink
